const Songs = [
    {
        title: 'Young in america',
        artist: 'Barns Courtney',
        rating: 8.5,
        link: 'https://open.spotify.com/embed/track/0Ef2EJ0YndF0GZMQHsrOvt?utm_source=generator'
    },
    {
        title: 'Something to Hide',
        artist: 'grandson',
        rating: 8,
        link: 'https://open.spotify.com/embed/track/1rjZicKSpIJ3WYffIK9Fuy?utm_source=generator'
    },
    {
        title: 'Golden Dandelions',
        artist: 'Barns Courtney',
        rating: 9,
        link: 'https://open.spotify.com/embed/track/5vdNoFezjTsQTrZxPK8tDg?utm_source=generator'
    },
    {
        title: 'Why Why Why',
        artist: 'Des Rocs',
        rating: 8.5,
        link: 'https://open.spotify.com/embed/track/6BNItr01F8lxtJhKI5SPtP?utm_source=generator'
    },
    {
        title: 'My Life Away',
        artist: 'Unlike Pluto', 
        rating: 8,
        link: 'https://open.spotify.com/embed/track/3in9STBrkg8yBV8qHluzcM?utm_source=generator'
    },
    {
        title: '.intoodeep.',
        artist: 'DEAD POET SOCIETY',
        rating: 8.5,
        link: 'https://open.spotify.com/embed/track/54jvLVojOWiQRubRfKmZ2k?utm_source=generator'
    },
    {
        title: 'Unnatural',
        artist: 'CRX',
        rating: 9,
        link: 'https://open.spotify.com/embed/track/4VrFcra9yIrGZzCLWLuUss?utm_source=generator&theme=0'
    }
]

const Books = [
    {
        title: 'Good Omens',
        author: 'Neil Gaiman & Terry Pratchett',
        summary: 'An angel and a demon make an unlikely alliance as they plot against Heaven and Hell to prevent the Apocalypse',
        rating: 9,
        image: 'https://cdn.kobo.com/book-images/af9e00bf-5f88-44c2-832e-40415f5d86ec/353/569/90/False/good-omens-1.jpg'
    },
    {
        title: 'The Martian',
        author: 'Andy Weir',
        summary: 'A simple mission on Mars for astronaut Mark Wartney takes a turn for the worse when he finds himself injured, alone, and stranded on the planet with no escape in sight',
        rating: 8.5,
        image: 'https://m.media-amazon.com/images/I/71SRkQ-DwZL._AC_UF1000,1000_QL80_.jpg'
    },
    {
        title: 'Crooked Kingdom',
        author: 'Leigh Bardugo',
        summary: 'Sequel to Six of Crows:Kaz and the rest of his crows attempt plan after plan to protect the secrets of Jurda Parem',
        rating: 9,
        image: 'https://m.media-amazon.com/images/I/91M9xpvW7HL._AC_UF1000,1000_QL80_.jpg'
    },
    {
        title: 'The King\'s Avatar',
        author: 'Hu Die Lan (Butterfly Blue)',
        summary: 'Forced into retirement, pro-gamer Ye Xiu finds himself a position in an internet cafe where he slowly works his way back into the Glory Professional Alliance',
        rating: 9,
        image: 'https://images-na.ssl-images-amazon.com/images/S/compressed.photo.goodreads.com/books/1534325914i/41148295.jpg'
    }
]

const Movies = [
    {
        title: 'Supernatural',
        summary: 'Two brothers drive across America, hunting monsters',
        rating: 7.5,
        obsession: 11,
        image: 'https://i0.wp.com/www.artstudio.org/wp-content/uploads/2015/09/Supernatural-supernatural-30545991-1680-1050.jpg?ssl=1'
    },
    {
        title: 'Elementary',
        summary: 'Sherlock Holmes, recovering addict, continues to solve mysteries with a sober companion by his side, Joan Watson',
        rating: 9,
        obsession: 6.5,
        image: 'https://play-images-prod-ctf.tech.tvnz.co.nz/api/v1/web/image/6RdYcb2UmoPYnMYQ3iXssq/3e05a705cf2195494ad65e4158935de9/Elementary_showtile.png.3e05a705cf2195494ad65e4158935de9.jpg?width=1200&height=630'
    },
    {
        title: 'Merlin',
        summary: 'In a land of myth and a time of magic, the destiny of a great kingdom rests on the shoulders of a young boy. His name... Merlin',
        rating: 8.5,
        obsession: 8,
        image: 'https://devontrevarrowflaherty.files.wordpress.com/2015/11/merlin.jpg?w=700&h=438'
    },
    {
        title: 'Doctor Who',
        summary: 'The Doctor, last of his kind, travels across all of time and space, saving people and picking up strays as he goes',
        rating: 8.5,
        obsession: 8,
        image: 'https://media.gq-magazine.co.uk/photos/5d13a343eef92125b19ffe56/16:9/w_2560%2Cc_limit/Doctor-Who-01-GQ-31Jan16_BBC_b.jpg'
    },
    {
        title: 'The Dark Knight',
        summary: 'The second movie in the Nolan Trilogy, Batman is faced with his greatest foe: The Joker',
        rating: 8.5,
        obsession: 7,
        image: 'https://m.media-amazon.com/images/S/pv-target-images/fd2a62ebf8534a10465dfc63ea11635bd42ed1692ad3af11d5e83ab553e3d0ae.jpg'
    }
]

export {Songs, Movies, Books};